import { PageType } from "../Types/PageType";
import { Page } from "./Page";
import { CompositeTimeSeriesData } from "./TimeSeriesData";

export class EEGPage extends Page<Map<string, CompositeTimeSeriesData>> {
    getType(): PageType {
        return PageType.EEG
    }
}